import { useEffect, useState } from "react"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { Product } from "../../../../products"
import { PricesList, SpecialDiscountItem } from "../../../state/types"
import { SpecialDiscountItemForm } from "./specialDiscountItemForm"

type Props = {
    defaultData?: SpecialDiscountItem
    pricesList: PricesList
    filterProducts?: (product: Product) => boolean
    onSubmit: (data: SpecialDiscountItem) => void
}

export const SpecialDiscountItemFormModal = (props: Props) => {
    const { defaultData, pricesList, filterProducts, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])

    return (
        <Modal
            modalId={ModalId.SPECIAL_DISCOUNT_ITEM_FORM}
            title="Agregar Descuento Especial"
            actions={[]}
            widthSize="l"
        >
            <SpecialDiscountItemForm
                key={key}
                defaultData={defaultData}
                pricesList={pricesList}
                filterProducts={filterProducts}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
